<template>
    <div class="lsit_box" v-if="postlists.data">   

        <!-- 항목 테이블 -->
        <div class="posts_wrap" >     
        <template v-if="postlists.data.length ===0">
            <tr><td colspan="6">해당 게시글이 없습니다.</td></tr>            
        </template>
        <template v-else>     
            <div v-for="(list, index) in postlists.data" :key="index" 
            :class="{'notice':list.notice===1}" class="post_block"
            @click="updateCount(list.id, list.document)"
            >           
                <div class="left_part">
                <div class="subject">
                    [{{list.document.title}}]
                    <span v-if="list.notice===1" class="notice_text">[공지]</span>
                    {{list.title}}
                </div>
                <div class="writer"> {{list.user.nic}}</div>
                <div class="time_count">
                    <span><display-time :time="list.created_at"/></span>
                    <span><font-awesome-icon :icon="['fas', 'eye']" /> {{list.recommend}}</span>
                    <span><font-awesome-icon :icon="['fas', 'heart']" /> {{list.count}}</span>
                </div>
                </div>

                <div class="thumb_comment">
                <div class="thumb">
                    <post-content :post="list" imgheight="56px" imgwidth="56px" radius="5" :isMobile="true" :titleview="false"/>
                </div>
                <div class="comment">
                    <span>{{list.comment}}</span>
                    <span>댓글</span>
                </div>
                </div>            
            </div>   
            </template>
    
      
        </div>
        <!-- 항목 테이블 -->

    </div>
</template>
<script>
import DisplayTime from '@/components/site/parts/DisplayTime.vue'

import PostContent from '@/components/posts/PostContent.vue'
import { postLink } from '@/utils/menu';
export default {
    name:'mobile_component_post_list',
    props:{
        postlists:{default:null},document:{default:null} ,searchview:{default:false}  
    },
    data(){
        return{

        }
    },
    mixins:[

    ],
    components:{
        DisplayTime,PostContent
    },
    mounted() {
    },
    methods:{
        updateCount(list_id,document){            
            const menu = this.$store.getters['menu/getMenu'].find((menu)=>menu.title === document.menu).name;           
            postLink(list_id,menu,document.name,this.$store);   
            
            let routeurl = `/m/community/${menu}/${document.name}/view/${list_id}`
            if(this.searchview)
            {            
              routeurl = `/m/community/postsearch/view/${list_id}`             
            }       
            this.$router.push(routeurl);  
            
            this.$emit('scroll-to-top');         
        }
    }
}
</script>
<style lang="scss" scoped>
.lsit_box {
    font-size: 12px;   
  .posts_wrap {
      padding: 10px 10px 0;
      background:#fff;
      min-height:660px;
      .post_block{
        display: flex;
        justify-content: space-between;
        border-bottom:1px solid #f2f2f2;
        padding:10px 0;
        .left_part{    
          width: calc(100% - 110px);       
           overflow: hidden;
           .subject{    
            
            overflow: hidden;         
            line-height: 19px;           
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 3px; 
          }
          .writer{

          }
          .time_count{
            display: flex;
            margin-top:3px;
            span{
              display: inline-block;
              padding-right: 5px;
            }
          }
        }
        .thumb_comment{
          display: flex;
          .comment{
            margin-left:3px;
            background:#f5f6f8;
            border-radius:5px;
            padding:10px;
            span{
              display:block;
              text-align: center;
              font-size:11px;
              color:#999;
            }
            span:first-child{
              color:#000;
              font-weight: bold;
              margin:5px 0;
            }
          }
        }
       
      }
      .notice{       
        font-weight:bold; 
        .notice_text{
          color:red;
        }
      }
      .article_title,
      .article_writer {
        color: #000;
        font-weight: normal;
      }

      .txt-left {
        text-align: left !important;
      }
  }
  .paginate{
    padding:20px 0 ;
  }
  
}
</style>